import React from 'react';
import { Wrapper } from './network-initial-loader.styles';
import { NetworkInitialLoaderProps } from './types';
import { Preloader } from '@vtbhome/juicyfront';

export const NetworkInitialLoader: React.FC<NetworkInitialLoaderProps> = ({ style, customState, className }) => {
    if (customState) {
        return customState;
    }

    return (
        <Wrapper style={style} className={className}>
            <Preloader size='l' />
        </Wrapper>
    );
};
